interface ProgressIndicatorProps {
  currentStep: number
  totalSteps: number
}

export function ProgressIndicator({ currentStep, totalSteps }: ProgressIndicatorProps) {
  return (
    <div className="flex items-center gap-2">
      {Array.from({ length: totalSteps }).map((_, index) => (
        <div
          key={index}
          className={`h-1 w-10 flex-1 md:w-14 md:flex-none ${index < currentStep ? 'bg-gray-400' : 'bg-gray-700'}`}
        />
      ))}
    </div>
  )
}
